const ProviderNameTransformer = (name) => {
  if (name === 'NUAPAY') return 'Nuapay';
  if (name === 'TOTAL_PROCESSING') return 'Trust Payments';
  if (name === 'NUVEI') return 'Nuvei';

  return name;
}

export default ProviderNameTransformer;
